import Stroke7 from './components/Stroke7'
import Svg from './components/Svg'

export default {
  Stroke7,
  Svg,
}
